const lbaPerDiem = angular.module('app.lbaPerDiem', [
 require('../lbaPerDiemGrid/lbaPerDiemGrid').name
]);

lbaPerDiem.controller('lbaPerDiemCtrl', require('./lbaPerDiemCtrl'));
lbaPerDiem.directive('lbaPerDiem', require('./lbaPerDiemDir'));
lbaPerDiem.service('perDiemService', require('../../services/perDiemService'));

export default lbaPerDiem;



// WEBPACK FOOTER //
// ./src/components/lbaPerdiem/index.js